import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import WarehouseTab from "./WarehouseTab";

function Warehouse () {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <WarehouseTab />
      <Footer />
    </DashboardLayout>
  );
}

export default Warehouse;